const data = {
  "404.heading": "Work in Progress",
  "unexpected.error.heading": "Sorry!",
  "unexpected.error.description": "Something unexpected has happened",
  "unexpected.error.back": "Back",
};

export default data;
